module.exports = __webpack_public_path__ + "static/img_prospector-961a5f2b01552395c7159149a01e93ee.png";